import { ColorPallet } from "../../utils/colorPallet";
const styles = {
    boxMarginTop: { mt: -2 },
    tableContainer: (showEditIcon: boolean) => ({
        maxHeight: {
            xs: showEditIcon ? "none" : 300,
            sm: showEditIcon ? "none" : 400,
            md: showEditIcon ? "none" : 350,
            lg: showEditIcon ? "none" : 600,
            xl: showEditIcon ? "none" : 700,
        },
        "@media (min-width:820px) and (max-width:900px)": {
            maxHeight: showEditIcon ? "none" : 550,
        },
        "@media (min-width:1023px) and (max-width:1050px)": {
            maxHeight: showEditIcon ? "none" : 210,
        },
        "@media (min-width:1200px) and (max-width:1280px)": {
            maxHeight: showEditIcon ? "none" : 400,
        },
        overflowY: "auto",
        overflowX: "auto",
        minWidth: { xs: "100%", sm: "600px" },
    }),
    table: {
        border: `1px solid ${ColorPallet.borderColor}`,
    },
    tableHead: {
        backgroundColor: ColorPallet.tableHeaderColor,
    },
    tableCellHeader: (headerItem: any) => ({
        border: `1px solid ${ColorPallet.borderColor}`,
        ...(headerItem === "Date" && { width: "125px" }),
        paddingY: "2px !important",
        paddingLeft: "8px !important",
    }),
    tableCellBody: {
        border: `1px solid ${ColorPallet.borderColor}`,
        paddingY: "2px !important",
        paddingLeft: "8px !important",
    },
    tableRowClickable: {
        cursor: "pointer",
    },
    actionBox: {
        display: "flex",
        alignItems: "center",
        gap: 0,
        spaceBetween: "flex-end",
        textAlign: "right",
        width: "10px",
    },
    editRowCell: (colSpan: number) => ({
        background: '#fff',
        p: 0,
    }),
    editRowBox: {
        overflowY: 'auto',
        boxShadow: "10px 10px 30px 15px #0000002B",
        p: 1,
        mb: 1,
        mx: 0.5,
        borderRadius: "5px"
    },
    paginationBox: {
        marginTop: "auto"
    }
};

export default styles;